import { Component } from '@angular/core';
import { GameService } from '../../../../shared/services/game.service';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { VoteMap } from '../../../../shared/interfaces/votemap.interface';
import { takeUntil } from 'rxjs/operators';
import { MessageService } from '../../../../shared/services/message.service';

@Component({
  selector: 'app-vote-result',
  templateUrl: './vote-result.component.html',
  styleUrls: ['./vote-result.component.scss']
})

export class VoteResultComponent {
  votesMap: VoteMap;
  faCoffee = faCoffee;
  private equalDeviation = false;

  constructor(private messageService: MessageService, private gameService: GameService) {
    gameService.votesMapReceived$
      .pipe(takeUntil(this.gameService.onDestroy$))
      .subscribe((newVoteMap: VoteMap) => {
        this.votesMap = newVoteMap;
        this.equalDeviation = this.votesMap.deviation == 0;
      }
    );
  }

  startNewRound() {
    this.gameService.startRound().catch(() => {
      this.messageService.showError("Er is iets fout gegaan bij het starten van een nieuwe ronde");
    });
  }
}
